'use client';

import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { alpha, useTheme } from '@mui/material/styles';

export function SocialProofSection() {
  const t = useTranslations('creator.serviceBot.socialProof');
  const theme = useTheme();

  return (
    <Box sx={{ py: { xs: 6, md: 8 } }}>
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <FormatQuoteIcon
          sx={{
            fontSize: 48,
            color: alpha(theme.palette.primary.main, 0.3),
            mb: 2,
          }}
        />
        <Typography
          variant="h6"
          component="blockquote"
          sx={{
            fontStyle: 'italic',
            color: 'text.secondary',
            mb: 2,
            lineHeight: 1.6,
          }}
        >
          {t('quote')}
        </Typography>
        <Typography variant="subtitle2" fontWeight={600}>
          {t('author')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {t('role')}
        </Typography>
      </Container>
    </Box>
  );
}
